module.exports = __webpack_public_path__ + "static/img/bg_site-hover.57d0b9c8.png";